import { SettingOutlined } from '@ant-design/icons';
import { Button, type ButtonProps, Popover } from 'antd';
import { useWatch } from 'react-hook-form';
import { type IReference } from '../../../references/IReference.ts';
import { useAsyncServiceEngineContext } from '../context/AsyncServicesEngineContext.tsx';
import { AsyncExpressionOptionsInput } from './AsyncExpressionOptionsInput.tsx';
import { AsyncServiceSelectInput } from './AsyncServiceSelectInput.tsx';

export interface IAsyncExpressionInputProps {
  name: string;
  references: IReference[];

  size?: ButtonProps['size'];

  disabled?: boolean;
}

/**
 * Permette di selezionare un servizio asincrono e di configurarne i parametri.
 */
export function AsyncExpressionInput(props: IAsyncExpressionInputProps) {
  const { name, references, size, disabled } = props;
  const asyncContext = useAsyncServiceEngineContext();

  const selectedId = useWatch({ name: `${name}.serviceId` });
  const selected = asyncContext.services.find(s => s.id === selectedId);

  return (
    <>
      <AsyncServiceSelectInput name={`${name}.serviceId`} disabled={disabled} />
      {selected && (
        <Popover
          trigger={['click']}
          content={
            <AsyncExpressionOptionsInput
              service={selected}
              size={size}
              name={name}
              references={references}
            />
          }
        >
          <Button size={size} icon={<SettingOutlined />}>
            Configura
          </Button>
        </Popover>
      )}
    </>
  );
}
